export const environment = {
  production: true,
  STRAVA_CLIENT_ID: "127134",
  STATIC_FORMS_ACCESS_KEY: "4dcc7f88-a92f-416f-8c59-559f186bd0a6",
  SUPABASE_URL: "https://shvjypxiwsbwcldvnybc.supabase.co",
  SUPABASE_KEY:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNodmp5cHhpd3Nid2NsZHZueWJjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTE0Mzg5ODAsImV4cCI6MjAyNzAxNDk4MH0.GtRujiXyvey-Rrk0xu2pqdTlliugi0JUhmEZLvCoimU",
};
